/**
 * Registers the `cwc-*` custom elements of the @cmx-web-components version declared
 * in package.json BEFORE any other bundle gets the chance to do it.
 *
 * Why: @cemex-app/cmx-module-cc embeds its own copy of @cmx-web-components/core and
 * registers every `cwc-*` tag as soon as it is imported. Custom elements can only be
 * defined once per tag, so the first registration wins. Without this file, the version
 * used at runtime depends on whatever cmx-module-cc was built with (this broke the
 * `cwc-entity-selector` internal-user search: `disableFilter` / `cwcInputChange`).
 *
 * This file must stay as the FIRST import of src/main.ts.
 */
import { defineCustomElements } from '@cmx-web-components/core/loader';

defineCustomElements(window);
